import React from "react";
import WorkshopFeedbackCard from "../../Components/Feedback/WorkshopFeedbackCard";
import "./WorkshopFeedbackPage.css";
import { Helmet } from "react-helmet";

function WorkshopFeedbackPage() {
  return (
    <>
      <Helmet>
        <title>MyBurgo - Parenting App | Pregnancy App | SelfCare App</title>
        <meta
          name="description"
          content="MyBurgo is India's comprehensive parenting app offering expert guidance, interactive workshops, personalized resources, and community support for parents and pregnant women. Empower your parenting journey with child development tools, curated recipes, mental health support, and more."
        />
      </Helmet>
      <div className="workshop-feedback-page">
        <div className="workshop-feedback-container">
          <WorkshopFeedbackCard />
        </div>
      </div>
    </>
  );
}

export default WorkshopFeedbackPage;
